import React from "react";
import { useSidebar } from "@/components/ui/sidebar";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function SidebarTrigger() {
  const { toggleSidebar } = useSidebar();
  return (
    <Button onClick={toggleSidebar}>
      <Menu />
    </Button>
  );
}
